import { Outlet } from 'react-router-dom';

import { AppShell } from '@/components/primitives/AppShell';

/** The chrome every page renders inside. `<Outlet />` is the matched route. */
export function RootLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
